import { Flex, Icon, Image, Text } from '@chakra-ui/react'
import { FaEye } from "react-icons/fa"
import { BsGithub } from "react-icons/bs"
import React from 'react'
import { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'
import { memo } from 'react'

const SingleProject = ({ data }) => {
    const { Theme } = useContext(ThemeContext)
    useEffect(() => {
        AOS.init();
    }, [])
    return (
        <Flex data-aos="zoom-in"
            data-aos-delay="100" p="3" borderRadius={"10"} mb={[3, 3, 0, 0, 0]} className="acheivementBoxshadow soft2" flexDir={"column"} justifyContent={"center"} border={Theme === "dark" && "2px solid #F2AA4CFF"} >
            <Image my="2" src={data.image} alt="" w="100%" h={["100px", "100px", "160px", "160px", "160px"]} />
            <Text color={Theme === "dark" ? "#fff" : "blackAlpha.700"} fontWeight={"500"} fontSize={["15", "15", "18", "18", "18"]} mb={[3, 3, 0, 0, 0]} >{data.name}</Text>
            <Text fontSize={["12", "12", "12", "12", "14"]} my="5" display={['none', 'none', 'block', 'block', 'block']} textAlign="left" color={Theme === "dark" ? "#ffffff" : "#363534"} >{data.desc}</Text>
            <Text mb='5' color={Theme === "dark" ? "#fff" : "blackAlpha.700"} fontSize={["11", "11", "13", "13", "13"]} textAlign={"center"} >
                <span style={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}` }} >Tech Stacks</span>{data.category}
            </Text>
            <Flex w={["40%", "40%", "30%", "30%", "30%"]} m="auto" flexDir={"row"} alignItems={"center"} justifyContent={"space-between"} mb='5' >
                <a href={data.source} target={"blank"} ><Icon fontSize={"20px"} transition="all .2s ease-in-out" _hover={{ transform: "scale(1.2)" }} color={Theme === 'dark' ? '#F2AA4CFF' : "#blackAlpha.700"} as={BsGithub} /></a>
                <a href={data.live} target={"blank"} ><Icon fontSize={"20px"} transition="all .2s ease-in-out" _hover={{ transform: "scale(1.2)" }} color={Theme === 'dark' ? '#F2AA4CFF' : "#blackAlpha.700"} as={FaEye} /></a>
            </Flex>
        </Flex>
    )
}

const customComparator = (prevProps, nextProps) => {
    return nextProps.post === prevProps.post;
  };
export default memo(SingleProject,customComparator)